// PublicFooter.js
import React from 'react';
import '../App.css';

export default function PublicFooter() {
    return (
        <footer className="public-footer">
            &copy; {new Date().getFullYear()} Stepwise Mfg Corp., All rights reserved.
        </footer>
    );
}
